import React, { Component } from 'react';
import ReactDOM from 'react-dom';
// import Docreg from '../User/doctorregistration/doctorreg'
// import Patientreg from '../User/patientregistration/pacientreg'
// import Posreg from '../User/POS/Posreg'
// import Opticianreg from '../User/opticianregistration/opticianreg'
// import Eyetest from '../EyetestComponent/Eyetest'
// import Eyeresult from '../EyetestComponent/Eyetestresult'
// import Profile from '../User/userprofile/UserProfile'
// import Settings from '../dashboardComponent/Settings';
// import Presc from '../Prescription/Prescription';
 import Ord from '../OrderComponent/Order';
 //import Dist from '../UserComponent/DistributorComponent/Distributor';
 import DistNew from '../UserComponent/DistributorComponent/DistributorNew';
 
 import Prod from '../ProductComponent/Product'
 import ProdNew from '../ProductComponent/ProductNew'
 import PriceUpload from '../PriceUploadComponent/PriceUpload'
import BackofficeNew from '../UserComponent/BackofficeComponent/BackofficeNew'
import Backoffice from '../UserComponent/BackofficeComponent/Backoffice'
import BucketMapping from '../BucketMappingComponent/BucketMapping'
import BlockTable from '../BlockTableComponent/BlockTable'
import Dash from '../Dashboardcomponent/Dashboard'
import $, { data } from 'jquery'
import ViewOrderNew from '../OrderComponent/vieworderNew'
import './side.css'

//import './side2.css'

class Dashboard2 extends Component {

    constructor(props) {

        super(props);
       
      
        this.state = {

            colapsed:1,

            email: localStorage.getItem("email"),
            utype: localStorage.getItem("type")

        }
        this.menuu = this.menuu.bind(this);
       
        this.ProdNewFunction = this.ProdNewFunction.bind(this);
        this.Prod = this.Prod.bind(this);
        this.Dist = this.Dist.bind(this);
        this.Ord = this.Ord.bind(this);
        this.Vieword = this.Vieword.bind(this);
         this.back = this.back.bind(this);
 
         this.SetEventBasedOnHideShow = this.SetEventBasedOnHideShow.bind(this);
         this.HideMenu = this.HideMenu.bind(this); 
         this.PriceUploadFunction = this.PriceUploadFunction.bind(this); 
         this.BucketMappingFunction = this.BucketMappingFunction.bind(this); 
         this.BlockTableFunction = this.BlockTableFunction.bind(this); 
         
        // this.patientreg = this.patientreg.bind(this);
        // this.posreg = this.posreg.bind(this);
        // this.opticianreg = this.opticianreg.bind(this);
        this.menu_obj=[{menu_name:"Dashboard",click_event:()=>this.dash() ,icon:"fas fa-tachometer-alt mr-50"}]
        if(localStorage.getItem("userType")=== "distributor" || localStorage.getItem("userType")=== "sales officer" || localStorage.getItem("userType")=== "back office")
            this.menu_obj.push({menu_name:"Product Master", click_event:()=>this.ProdNewFunction() ,icon:"fab fa-product-hunt mr-50"})
        if( localStorage.getItem("userType")== "sales officer" || localStorage.getItem("userType")== "back office")
            this.menu_obj.push({menu_name:"Distributor Master",  click_event:()=>this.Dist() ,icon:"fas fa-user-circle mr-50"})
        if( localStorage.getItem("userType")=== "back office")
            {
            this.menu_obj.push({menu_name:"User Master", click_event:()=>this.back()  ,icon:"fas fa-user mr-50"})
            this.menu_obj.push({menu_name:"Display Bucket Mapping", click_event:()=>this.BucketMappingFunction()  ,icon:"fas fa-upload mr-50"})
            this.menu_obj.push({menu_name:"Block Table Mapping", click_event:()=>this.BlockTableFunction() ,icon:"fas fa-upload mr-50"})
            }
        if( localStorage.getItem("userType")=== "back office" || localStorage.getItem("userType")=== "price manager")
            {
                this.menu_obj.push( {menu_name:"Price Upload", click_event:()=>this.PriceUploadFunction(),icon:"fas fa-upload mr-50"})
            }  
        if(localStorage.getItem("userType")=== "distributor" || localStorage.getItem("userType")=== "sales officer")
            {         
            this.menu_obj.push(   {menu_name:"Place Order",click_event:()=>this.Ord()  ,icon:"fas fa-cart-plus mr-50"})
            }
        if( localStorage.getItem("userType")!= "price manager")
             this.menu_obj.push( {menu_name:"View Order", click_event:()=>this.Vieword(),icon:"fas fa-eye mr-50"})
        if( localStorage.getItem("userType")=== "BM" || localStorage.getItem("userType")=== "ZSM")
             {
                this.menu_obj=[{menu_name:"Dashboard",click_event:()=>this.dash() ,icon:"fas fa-tachometer-alt mr-50"}]
             }  
 
    }
    // submit() {

    // }
    
    SetEventBasedOnHideShow()
    {
        this.setState({colapsed:2})
    }
    back(){
        this.SetEventBasedOnHideShow();
        console.log("hi")
        ReactDOM.render(<BackofficeNew/>, document.getElementById('c11'));
        this.HideMenu();
       }
       
       
       Prod(){
      
      this.SetEventBasedOnHideShow();

        ReactDOM.render(<Prod />, document.getElementById('c11'));
        this.menuu();
       }
       ProdNewFunction(){
        this.SetEventBasedOnHideShow();
        //alert(3)
        //this.props.onHeaderMenuHide();
        ReactDOM.render(<ProdNew />, document.getElementById('c11'));
          this.HideMenu();
        
       
        
       }
       Dist(){
        this.SetEventBasedOnHideShow();
        console.log("hi")
      
        ReactDOM.render(<DistNew />, document.getElementById('c11'));
        this.HideMenu();
       }
       PriceUploadFunction()
       {
        this.SetEventBasedOnHideShow();
        console.log("hi")
      
        ReactDOM.render(<PriceUpload />, document.getElementById('c11'));
        this.HideMenu();
       }
       BucketMappingFunction()
       {
        this.SetEventBasedOnHideShow();
        console.log("hi")
      
        ReactDOM.render(<BucketMapping />, document.getElementById('c11'));
        this.HideMenu();
       }
       BlockTableFunction()
       {
        this.SetEventBasedOnHideShow();
        console.log("hi")
      
        ReactDOM.render(<BlockTable />, document.getElementById('c11'));
        this.HideMenu();
       }
       
       Ord(){
        this.SetEventBasedOnHideShow();
        console.log("hi")
        ReactDOM.render(<Ord />, document.getElementById('c11'));
        this.HideMenu();
       }
       HideMenu()
        {
            document.getElementById("menubarkor").removeAttribute("class")
            document.getElementById("menubarkor").setAttribute("class","main-menu menu-fixed menu-light menu-accordion menu-shadow")
    
            document.getElementById("root").removeAttribute("class")
            
            document.getElementById("root").setAttribute("class","vertical-layout navbar-floating footer-static pace-done vertical-menu-modern menu-collapsed")
    
        }
       menuu()
       {
           console.log("menu te dhukechi--"+this.state.colapsed)
          
           if(this.state.colapsed==1){
               document.getElementById("menubarkor").removeAttribute("class")
               document.getElementById("menubarkor").setAttribute("class","main-menu menu-fixed menu-light menu-accordion menu-shadow")
        
               document.getElementById("root").removeAttribute("class")
               
               document.getElementById("root").setAttribute("class","vertical-layout navbar-floating footer-static pace-done vertical-menu-modern menu-collapsed")
        
               this.setState({colapsed:2})
            }
           else{
            document.getElementById("menubarkor").removeAttribute("class")
            document.getElementById("menubarkor").setAttribute("class","main-menu menu-fixed menu-light menu-accordion menu-shadow expanded")
            document.getElementById("root").removeAttribute("class")
               
            document.getElementById("root").setAttribute("class","vertical-layout navbar-floating footer-static pace-done vertical-menu-modern menu-expanded")
     
            this.setState({colapsed:1})
           }
       }

       Vieword(){
        this.SetEventBasedOnHideShow();
        console.log("hi")
       
        ReactDOM.render(<ViewOrderNew />, document.getElementById('c11'));
        this.HideMenu();
       }   
       dash(){
         
        console.log("hi")
        window.location.reload();
      //  ReactDOM.render(<Dash />, document.getElementById('c11'));
       }
       
    render() {


        return (



            <div id="menubarkor"  class="main-menu menu-fixed menu-light menu-accordion menu-shadow expanded" data-scroll-to-active="true">


        <div class="navbar-header">
            <ul class="nav navbar-nav flex-row">
                <li class="nav-item mr-auto">
                    <img onClick={()=>this.menuu()} class="w-75 ml-2"  src="../../../app-assets/images/pages/Weikfield-RGB-02.png" alt=""/>
                    </li>
              
            </ul>
        </div>
        <div class="shadow-bottom"></div>
        <div class="main-menu-content mt-2">
            <ul class="nav navbar-nav" id="main-menu-navigation" data-menu="menu-navigation">
            
            
                    {
                        this.menu_obj.map((link) =>
                            
                        <li data-menu=""><a class="dropdown-item d-flex align-items-center hover-color"  onClick={link.click_event}  data-i18n="Edit"> 
                        <i class={link.icon}></i> <span data-i18n="Edit">{link.menu_name}</span></a> </li>
     
                     )
                        
                    }                
                            </ul>


                {/* <hr class="my-0" />
                        
                
               
                <ul class="nav navbar-nav" id="main-menu-navigation" data-menu="menu-navigation">
                {localStorage.getItem("userType")!== "back office"  && localStorage.getItem("userType")!== "approver"  ?  <li data-menu=""><a class="dropdown-item d-flex align-items-center" onClick={this.Ord} data-i18n="Edit"><i class="fas fa-cart-plus mr-50"></i><span data-i18n="Edit">Place Order</span></a>
                                        </li>:null}
                <li data-menu=""><a class="dropdown-item d-flex align-items-center" onClick={this.Vieword} data-i18n="Edit"><i class="fas fa-eye mr-50"></i><span data-i18n="Edit">View Order</span></a>
                                </li>
                    </ul> */}
            </div> 
    
   
 
        </div>
      



        );


    }
}
export default Dashboard2